import React, { ChangeEvent, memo, useMemo, useState } from 'react'
import { useSelector } from '@tabeeb/store'

import {
  withModernTheme,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
} from '@collaborate-health/uikit'
import { getContentId } from '@tabeeb/shared/content/selectors'
import { useSelectedItemMenu } from '@tabeeb/shared/utils/hooks'

import { InviteWithQualificationsResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import { ManageUsersTabs } from '@tabeeb/modules/invites/types'
import { ParticipantsList } from '@tabeeb/modules/invites/components/ParticipantsList'
import InviteMenu from '../InviteMenu'
import InvitesList from '../InvitesList'
import InviteUsersForm from '../InviteUsersForm'

import { useContentInvites } from '../../hooks'

interface ManageUsersDialogProps {
  open: boolean
  onClose: () => void
}

const ManageUsersDialog: React.FC<ManageUsersDialogProps> = ({ open, onClose }) => {
  const contentId = useSelector(getContentId)

  const {
    loaded,
    invites,
    onCancelInvite,
    onCopyInviteLink,
    onResendInvite,
    onRevokeQuickAccessLink,
    onSetQuickAccessLinkPassword,
    onSendInvites,
    onUpdateInviteTime,
    onUpdateInviteRole,
  } = useContentInvites({
    open,
    contentId,
  })

  const {
    anchorEl,
    item: invite,
    open: menuOpen,
    onOpen: onOpenMenu,
    onClose: onCloseMenu,
  } = useSelectedItemMenu<InviteWithQualificationsResponse>()

  // TODO: Bring back tabs when participants management when DJ is ready
  const [selectedTabId, setSelectedTabId] = useState(ManageUsersTabs.Invites)

  const tabs = useMemo(
    () => [
      {
        id: ManageUsersTabs.Invites,
        label: 'Invites',
        render: () => (
          <>
            <InviteUsersForm onSendInvites={onSendInvites} />
            <InvitesList
              loaded={loaded}
              invites={invites}
              onUpdateInviteRole={onUpdateInviteRole}
              onOpenMenu={onOpenMenu}
            />
          </>
        ),
      },
      {
        id: ManageUsersTabs.Participants,
        label: 'Participants',
        render: () => <ParticipantsList />,
      },
    ],
    [invites, loaded, onOpenMenu, onSendInvites, onUpdateInviteRole]
  )

  const selectedTab = useMemo(() => {
    return tabs.find((tab) => tab.id === selectedTabId)
  }, [selectedTabId, tabs])

  return (
    <>
      <Dialog maxWidth='md' PaperProps={{ style: { maxWidth: 700 } }} fullWidth open={open} onClose={onClose}>
        <DialogTitle>Invite users</DialogTitle>
        {/* <DialogTitle>Manage users</DialogTitle> */}
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            // height: '70vh',
          }}
        >
          {/* <Tabs
            variant='fullWidth'
            value={selectedTabId}
            onChange={(_: ChangeEvent<{}>, value: ManageUsersTabs) => setSelectedTabId(value)}
          >
            {tabs.map(({ id, label }) => (
              <Tab key={id} value={id} label={label} />
            ))}
          </Tabs>
          {selectedTab && selectedTab.render()} */}
          {tabs.find((tab) => tab.id === ManageUsersTabs.Invites)!.render()}
        </DialogContent>
        <DialogActions>
          <Button variant='text' color='primary' onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {invite && (
        <InviteMenu
          anchorEl={anchorEl}
          invite={invite}
          open={menuOpen}
          onClose={onCloseMenu}
          onCancelInvite={onCancelInvite}
          onCopyInviteLink={onCopyInviteLink}
          onUpdateInviteTime={onUpdateInviteTime}
          onResendInvite={onResendInvite}
          onRevokeQuickAccessLink={onRevokeQuickAccessLink}
          onSetQuickAccessLinkPassword={onSetQuickAccessLinkPassword}
        />
      )}
    </>
  )
}

export default memo(withModernTheme(ManageUsersDialog))

